<template>
  <div class="reload-box" v-show="refreshShow">
    <div class="reload-mask"></div>
    <div class="reload-content">
      <div class="info">
        <img class="avatar" src="./../../../assets/image/reload-img.png" alt="" />
        <p class="text">该课程已经获得证书，请点击刷新</p>
        <div class="now-apply" @click="handleRefresh">立即刷新</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reload-box',
  props: {
    refreshShow: {
      type: Boolean
    }
  },
  methods: {
    handleRefresh() {
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.reload-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  .reload-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
    z-index: 100;
  }
  .reload-content {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -50%;
    width: 80%;
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;
    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 16px 0;
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;
      .avatar {
        width: 167px;
        height: 100px;
      }
      .text {
        margin-top: 20px;
        font-size: 15px;
        color: #303133;
      }
      .now-apply {
        margin-top: 24px;
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #4465f3;
        border-radius: 20px;
        font-size: 14px;
        box-sizing: border-box;
        background-color: #4670f4;
        color: #fff;
      }
    }
  }
}
</style>
